import React from "react"
import Social3D from "../components/social3D"
import { addColour } from "./rich-text-colour"
import { addSizes } from "./rich-text-size"

export const extendRichText = (children = []) => {
  const mappedChildren = children.flatMap((child) => {
    if (typeof child === "string") {
      if (child.match(/\[purple-play-now]/g)) {
        return "" // use it in card-section.tsx, implement with useState(). so cant be here.
      }
      if (child.match(/\[3d-social]/g)) {
        return <Social3D key={"social-3d"} />
      }
      if (child.match(/\[space-(\w+px)\]/)) {
        const matches = child.match(/\[space-(\w+px)\]/)
        return (
          <span
            style={{ height: matches[1], width: "100%", display: "block" }}
            key={Math.random()}
          ></span>
        )
      }
    }

    return child
  })

  return addSizes(addColour(mappedChildren))
}
